import PropTypes from 'prop-types';
import React from 'react';

const LeftArrowWhiteIcon = ({ className }) => (
  <svg
    width="17"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.71474 10.2803L0.219691 5.7856C-0.0463885 5.5195 -0.0707986 5.1032 0.146611 4.8096L0.219092 4.7255L4.71415 0.220599C5.00672 -0.0726006 5.4816 -0.0731013 5.77481 0.219498C6.0414 0.485498 6.066 0.902098 5.84849 1.1959L5.77596 1.2801L2.55911 4.503L15.2549 4.5023C15.6346 4.5023 15.9484 4.7845 15.9981 5.1506L16.0049 5.2523C16.0049 5.632 15.7228 5.9458 15.3567 5.9955L15.2549 6.0023L2.55711 6.003L5.77537 9.21965C6.0416 9.48591 6.0659 9.90257 5.84802 10.1962L5.7754 10.2803C5.50914 10.5466 5.09248 10.5708 4.79886 10.353L4.71474 10.2803Z"
      fill="#27B0E0"
    />
  </svg>
);

LeftArrowWhiteIcon.propTypes = {
  className: PropTypes.string,
};

LeftArrowWhiteIcon.defaultProps = {
  className: undefined,
};

export default LeftArrowWhiteIcon;
